export const ESSALUD = 1
export const ONP = 2
export const SCTR = 3
export const DOMINICAL = 4
export const TOPE_SALARIO = 5
